import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
import experimentSchemas from '../../../experiments.yaml';
const experiments = experimentSchemas;
export const treatmentsClient = createClient({
  quickFetchLabel: 'experiment-treatments',
  experiments,
  identifiers: {
    portalId: PortalIdParser.get()
  }
});